import { Injectable } from '@angular/core';
import { BackendHttpService } from './backend-http.service';

import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BackendService extends BackendHttpService{




}
